import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

function NumberBadge(props: HTMLAttributes<HTMLDivElement>) {
    return (<Base {...props}/>);
}

const Base = styled.div`
    width: var(--spacing-3);
    height: var(--spacing-3);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-icon-error);
    border-radius: var(--radius-full);
    color: var(--color-text-reverse);
    font-size: var(--font-size-label-sm);
    font-weight: 500;
`;

export default NumberBadge;
